import { Card, Box, IconButton } from '@mui/material';
import { Eye, TrashSimple } from '@phosphor-icons/react';

type Props = {
  src: string;
  alt?: string;
  onDelete: () => void;
  onView: () => void;
  aspectRatio?: string; // e.g., "2/3", "9/16", "4/3"
};

export default function MediaCard({
  src,
  alt,
  onDelete,
  onView,
  aspectRatio,
}: Props) {
  return (
    <Card
      sx={{
        p: 1,
        position: 'relative',
        ...(aspectRatio
          ? {
              width: 120,
              aspectRatio: aspectRatio,
            }
          : {}),
      }}
    >
      <img
        src={src}
        alt={alt ?? ''}
        style={{
          borderRadius: 10,
          objectFit: 'cover',
          ...(aspectRatio
            ? {
                width: '100%',
                height: '100%',
              }
            : {
                width: 153,
                height: 104,
              }),
        }}
      />

      {/* Overlay with icons - only visible on hover */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          top: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
          p: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          opacity: 0,
          transition: 'opacity 0.2s ease-in-out',
          '&:hover': {
            opacity: 1,
          },
          '.MuiCard-root:hover &': {
            opacity: 1,
          },
        }}
      >
        <IconButton size="small" onClick={onView} sx={{ color: 'white' }}>
          <Eye size={24} />
        </IconButton>
        <IconButton size="small" onClick={onDelete} sx={{ color: 'white' }}>
          <TrashSimple size={24} />
        </IconButton>
      </Box>
    </Card>
  );
}
